var include_seven_namda_bnr = `
<a href="https://www.7card.co.jp/lp/plus/nanaco/namda.html" target="_blank" class="conversion-btn__bnr Nanaco_Lead7cardLink CvContentsArea01">
    <img src="/material/img/common/bnr/bnr_sevencard_plus.png" alt="年会費永年無料 セブンカード・プラス入会キャンペーン実施中 8月入会・登録・利用で最大5,200nanacoポイントプレゼント" class="pc-only">
    <img src="/material/img/common/bnr/bnr_sevencard_plus_sp.png" alt="年会費永年無料 セブンカード・プラス入会キャンペーン実施中 8月入会・登録・利用で最大5,200nanacoポイントプレゼント" class="sp-only">
</a>
`;